module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./message.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/message.md
// module id = uQgP
// module chunks = 0